import imageDog from 'assets/image/snail-looking-for.png'
import clsx from 'clsx'
import { CampaignsUI } from 'features/campaigns'
import { Button } from 'shared/ui'

import css from './NoCampaignsYetTemplate.module.css'
export function NoCampaignsYetTemplate() {
	return (
		<article className={css.body}>
			<h1 className={clsx(css.title, 'h-2 title')}>Ready to start?</h1>
			<img alt='snail' className={css.pic} src={imageDog} width={150} />
			<p className={css.lead}>
				No campaigns yet. <br />
				Create your first campaign to get more leads on LinkedIn
			</p>

			<Button className={css.button} onClick={CampaignsUI.Creating.open}>
				Create now
			</Button>
		</article>
	)
}
